var classes = {"weekdaysRow":"WDBAj","weekday":"KGjl9"};

export { classes as default };
